import { render, staticRenderFns } from "./servicesList.vue?vue&type=template&id=112f746c&scoped=true&"
import script from "./servicesList.vue?vue&type=script&lang=js&"
export * from "./servicesList.vue?vue&type=script&lang=js&"
import style0 from "./servicesList.vue?vue&type=style&index=0&id=112f746c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f746c",
  null
  
)

export default component.exports